module.exports = __webpack_public_path__ + "img/NBA_FreeThrow2.73c0aefc.png";